import React from 'react'
import Alert from 'react-bootstrap/Alert'


const Description = ({ description }) => {
    if(description === null || description.length === 0) return null
     return (
       <Alert variant="primary">{description}</Alert>
     )
  }

export default Description;